import React from "react";

const VideoPlayer = ({ src, width = 640, height = 360, autoPlay = false, loop = false, controls = true }) => {
  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <video
        width={width}
        height={height}
        controls={controls}
        autoPlay={autoPlay}
        loop={loop}
        style={{ borderRadius: "8px", boxShadow: "0 0 10px rgba(0,0,0,0.2)" }}
      >
        <source src={src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoPlayer;